import { Box, Divider, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { GreetingsProps } from ".";

export const Greetings = (props: GreetingsProps) => {
    const { showUsername, showCompany } = props;
    const { user, selectedCompany } = useFoodpilotContext();
    const theme = useTheme();

    const shouldShowUsername = showUsername === "true";
    const shouldShowCompany = showCompany === "true";
    const showAnyGreeting = shouldShowUsername || shouldShowCompany;

    if (!showAnyGreeting) {
        return null;
    }

    return (
        <Box mb={theme.spacing(4)}>
            <Stack
                direction="row"
                spacing={theme.spacing(4)}
                alignItems="baseline"
                divider={shouldShowUsername && shouldShowCompany ? <Divider orientation="vertical" flexItem /> : null}
            >
                {shouldShowUsername && (
                    <Typography variant="h1">
                        {t("glossary.hello")} {user?.trustedUser?.firstname}
                    </Typography>
                )}
                {shouldShowCompany && (
                    <Typography
                        variant="h3"
                        fontWeight={theme.typography.fontWeightLight}
                        sx={{
                            transform: `translateY(${theme.spacing(-0.5)})`,
                        }}
                    >
                        {selectedCompany?.name}
                    </Typography>
                )}
            </Stack>
        </Box>
    );
};
